import React from 'react';
import './PC.css';
import Bamieh from '../../img/PC/Bamieh.png'
import Islam from '../../img/PC/Islam.png'
import Maraschi from '../../img/PC/Maraschi.png'
import Martin from '../../img/PC/Martin.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Maraschi,
          name: 'Luca Maraschi',
          position: 'CTO - Chief Technology Officer',
          ln: 'https://www.linkedin.com/in/lucamaraschi/',
        },
        {
          photo: Islam,
          name: 'Zahidul Islam',
          position: 'VP of Engineering',
          ln: 'https://www.linkedin.com/in/zahiduli/',
        },
        {
          photo: Martin,
          name: 'Nico Martin',
          position: 'Frontend Developer',
          tw: 'https://twitter.com/nic_o_martin',
          github: 'https://github.com/nico-martin',
          website: 'https://nico.dev/',
        },
        {
          photo: Bamieh,
          name: 'Ahmad Bamieh',
          position: 'Software Engineer',
          ln: 'https://www.linkedin.com/in/ahmadbamieh/',
          tw: 'https://twitter.com/AhmadBamieh',
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc container" id='pc'>
              <h3>Program committee</h3>
              <div className='pc_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}